/**
 * Where the pairing key lives, per platform.
 *
 * It is the only credential this app has — there are no accounts — so on a phone it belongs in the
 * keychain rather than in a plain key-value store. SecureStore has no web implementation, and on
 * the web the app is served from the same origin as the API anyway, so localStorage is both the
 * available answer and the one the Angular client already used.
 */
import { Platform } from 'react-native';
import * as SecureStore from 'expo-secure-store';

export async function getItem(key: string): Promise<string | null> {
  if (Platform.OS === 'web') {
    try {
      return globalThis.localStorage?.getItem(key) ?? null;
    } catch {
      return null;
    }
  }
  return SecureStore.getItemAsync(key).catch(() => null);
}

export async function setItem(key: string, value: string): Promise<void> {
  if (Platform.OS === 'web') {
    try {
      globalThis.localStorage?.setItem(key, value);
    } catch {
      /* private mode */
    }
    return;
  }
  await SecureStore.setItemAsync(key, value).catch(() => undefined);
}

export async function removeItem(key: string): Promise<void> {
  if (Platform.OS === 'web') {
    try {
      globalThis.localStorage?.removeItem(key);
    } catch {
      /* private mode */
    }
    return;
  }
  await SecureStore.deleteItemAsync(key).catch(() => undefined);
}
